export const getContextToken = (contextId: string) => ({
  contextId,
  contextType: 'ForumPost',
});
